export const iconFontAwesomeCampingTentArrowLeftRight = (
	<i className="fa-solid fa-tent-arrow-left-right"></i>
);
